import { faUserHeadset } from "@fortawesome/pro-solid-svg-icons";
import { useServiceContext } from "@tosize/ui";
import { useIntl } from "react-intl";
import { useConfig } from "../../context/ConfigContext";
import FloatingButton from "../FloatingButton";

export function Chat() {
	const intl = useIntl();
	const { mode } = useConfig();
	const { onOpenHandler, chatActive } = useServiceContext();

	if (mode !== "add") {
		return null;
	}

	return (
		<div className="absolute top-4 right-4 hidden xl:block">
			<FloatingButton
				onClick={() => onOpenHandler()}
				active={chatActive}
				icon={faUserHeadset}
				label={intl.formatMessage({ defaultMessage: "Hulp nodig?" })}
				size="small"
				color="white"
				alwaysShowLabel
			/>
		</div>
	);
}
